import { render } from "./Providers.vue?vue&type=template&id=e3eeedf6&scoped=true&ts=true"
import script from "./Providers.vue?vue&type=script&lang=ts"
export * from "./Providers.vue?vue&type=script&lang=ts"

import "./Providers.vue?vue&type=style&index=0&id=e3eeedf6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3eeedf6"]])

export default __exports__